<div class="container-fluid">
  <div class="row manageaccount mt-3">
    <div class="col-md-12 my-auto">
      <div class="d-flex align-items-baseline justify-content-between">
        <h1 class="fs-4 fw-bold mb-0">View Tracker</h1>
        <button
          class="btn btn-dark btn-sm"
          matTooltip="Back"
          matTooltipPosition="left"
          mat-raised-button
          (click)="backTo()"
        >
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>
      <nav class="breadcrumbMaine" aria-label="breadcrumb mb-0">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item" routerLink="/superAdmin/lrmanagement">
            Manage Tracker
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            View Tracker
          </li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="row mt-3">
    <div class="contentbox mb-3">
      <div class="row account">
        <div class="detailsBox col-xl-12">
          <div class="row">
            <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
              <h4 class="text-dark fw-bold mb-0">Basic Deatils</h4>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>System LR No.</label>
                <h5>{{ particlarLR?.Tracker_no ?? "N/A" }}</h5>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Company Name</label>
                <h5>{{ clientName ?? "N/A" }}</h5>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Supervisor Name</label>
                <h5>{{ particlarLR?.supervisorName ?? "N/A" }}</h5>
              </div>
            </div>
          </div>
          <!-- Vehicle Information Section -->
          <div class="row">
            <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
              <h4 class="text-dark fw-bold mb-0">Vehicle Details</h4>
            </div>

            <!-- First Row -->
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Vehicle No</label>
                <h5>{{ particlarLR?.vehicleDetail?.vehicle_no || "N/A" }}</h5>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Starting Meter Reading</label>
                <h5>{{ particlarLR?.startmeterReading || "N/A" }}</h5>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>End Meter Reading</label>
                <h5>{{ particlarLR?.endmeterReading || "N/A" }}</h5>
              </div>
            </div>

            <!-- Second Row -->
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Vehicle Type</label>
                <h5>{{ particlarLR?.vehicleDetail?.type || "N/A" }}</h5>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Usage KM</label>
                <h5>{{ particlarLR?.up_down_km || "N/A" }}</h5>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>FIX / Adhoc</label>
                <h5>{{ particlarLR?.fixAdhoc || "N/A" }}</h5>
              </div>
            </div>

            <!-- Third Row -->
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Trip Starting Date</label>
                <h5>
                  {{
                    particlarLR.tripStartDate
                      ? (particlarLR.tripStartDate | date)
                      : "N/A"
                  }}
                </h5>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Trip End Date</label>
                <h5>
                  {{
                    particlarLR.tripEndDate
                      ? (particlarLR.tripEndDate | date)
                      : "N/A"
                  }}
                </h5>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Total Hours</label>
                <h5>{{ particlarLR.totalhour || "N/A" }}</h5>
              </div>
            </div>

            <!-- Fourth Row -->
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>From</label>
                <h5>{{ particlarLR?.from || "N/A" }}</h5>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>To</label>
                <h5>{{ particlarLR?.to || "N/A" }}</h5>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Extra Hours</label>
                <h5>{{ particlarLR?.extrahour || "N/A" }}</h5>
              </div>
            </div>

            <!-- Fifth Row -->
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Number of Tolls</label>
                <h5>{{ particlarLR?.noofTools || "N/A" }}</h5>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Vehicle Rate </label>
                <h5>{{ particlarLR?.vehicleRate || "N/A" }}</h5>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Advance</label>
                <h5>{{ particlarLR?.advance ?? "N/A" }}</h5>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Balance Paid</label>
                <h5>{{ particlarLR?.balancePaid ?? "N/A" }}</h5>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Actual Balance</label>
                <h5>{{ particlarLR?.balance ?? "N/A" }}</h5>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>TDS</label>
                <h5>{{ particlarLR?.TDS ?? "N/A" }}</h5>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Other Payment</label>
                <h5>{{ particlarLR?.otherPayment ?? "N/A" }}</h5>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Other Payment Description</label>
                <h5>{{ particlarLR?.otherPaymentDescription ?? "N/A" }}</h5>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Final Amount</label>
                <h5>{{ particlarLR?.finalAmount ?? "N/A" }}</h5>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>DLY No</label>
                <h5>{{ particlarLR?.dly_no ?? "N/A" }}</h5>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Order ID</label>
                <h5>{{ particlarLR?.orderId ?? "N/A" }}</h5>
              </div>
            </div>

          </div>
        </div>

        <!-- invoice -->
        <div class="col-xl-12 mb-2">
          <div class="contentbox mt-3">
            <div class="row account">
              <div class="col-xl-12">
                <div
                  class="d-flex align-items-baseline justify-content-between"
                >
                  <h1 class="fs-4 fw-bold mb-0">Invoice Details</h1>
                  <!-- <button
                  class="btn btn-dark btn-sm"
                  mat-raised-button
                  (click)="addnewinv(particlarLR.tracker._id)"  
                >
                  + Add New Invoice
                </button> -->
                </div>
              </div>

              <div class="col-md-12 mt-3 table-responsive">
                <!-- Show table only if invoices exist -->
                <table
                  datatable
                  class="tablelist"
                  *ngIf="particlarLR?.invoice_no?.length > 0"
                >
                  <thead>
                    <tr>
                      <th>Number of Articles</th>
                      <th>Invoice No</th>
                      <th>Customer Name</th>
                      <th>Invoice Value (₹)</th>
                      <th>Weight</th>
                      <!-- <th>Attachment</th> -->
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let inv of particlarLR.invoice_no">
                      <td>{{ inv.NoofArticle || "N/A" }}</td>
                      <td class="" style="padding-left: 30px">
                        {{ inv.InvoiceNo || "N/A" }}
                      </td>
                      <td class="" style="padding-left: 30px">
                        {{ inv.customerName || "N/A" }}
                      </td>
                      <td class="" style="padding-left: 30px">
                        {{ inv.InvoiceValue || "N/A" }}
                      </td>
                      <td class="" style="padding-left: 30px">
                        {{ inv.Weight || "N/A" }}
                      </td>
                      <!-- <td>
                      <a *ngIf="inv.path" [href]="inv.path" target="_blank">View</a>
                      <span *ngIf="!inv.path">N/A</span>
                    </td> -->
                      <td>
                        <button
                          (click)="editInvoice(inv, particlarLR?._id)"
                          class="btn btn-block p-0 shadow-none"
                        >
                          <i matTooltip="Edit" class="fas fa-pen"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <!-- Show message if no invoice present -->
                <div
                  *ngIf="!particlarLR?.invoice_no?.length"
                  class="text-center text-muted py-3"
                >
                  No invoices added yet.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
